import { apiClient } from './api';
import type {
  RestoreTenantDeletionCommand,
  RestoreTenantResult,
  ScheduleTenantDeletionCommand,
  ScheduleTenantDeletionResult,
  TenantDeletionPreviewResult,
  TenantLifecycleListItem,
  TenantLifecycleStatusResult,
  TenantSubscriptionResult,
  UpdateTenantSubscriptionCommand,
  SetTenantDeletionProtectionCommand,
  SetTenantPurgeApprovalCommand,
  TenantDeletionProtectionResult,
  TenantPurgeApprovalResult,
} from '../types/tenantLifecycle';

export const tenantLifecycleApi = {
  listTenants(): Promise<TenantLifecycleListItem[]> {
    return apiClient.listTenantLifecycleTenants();
  },

  preview(tenantId: string): Promise<TenantDeletionPreviewResult> {
    return apiClient.previewTenantDeletion(tenantId);
  },

  updateSubscription(command: UpdateTenantSubscriptionCommand): Promise<TenantSubscriptionResult> {
    return apiClient.updateTenantSubscription(command);
  },

  setDeletionProtection(command: SetTenantDeletionProtectionCommand): Promise<TenantDeletionProtectionResult> {
    return apiClient.setTenantDeletionProtection(command);
  },

  setPurgeApproval(command: SetTenantPurgeApprovalCommand): Promise<TenantPurgeApprovalResult> {
    return apiClient.setTenantPurgeApproval(command);
  },

  schedule(command: ScheduleTenantDeletionCommand): Promise<ScheduleTenantDeletionResult> {
    return apiClient.scheduleTenantDeletion(command);
  },

  restore(command: RestoreTenantDeletionCommand): Promise<RestoreTenantResult> {
    return apiClient.restoreTenantDeletion(command);
  },

  getStatus(tenantId: string): Promise<TenantLifecycleStatusResult> {
    return apiClient.getTenantLifecycleStatus(tenantId);
  },
};
